import api from "../api"
export default {
    
	/**
     * 
     * @param {number} expiry 
     * @param {string} name 
     */
	async createInvitationCode(expiry, name, multipleRedeem) {
		let value = await api.post(`/invitation-codes/`, {
			expiry,
			name,
			multipleRedeem
		})
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	},
	/**
     * Delete invitation code
     * @param {string} id Invitaiton code
     */
	async deleteInvitationCode(id) {
		if (typeof id !== "string" || id.length < 1) {
			throw new Error("ID must be a string longer than 0")
		}
		let value = await api.delete(`/invitation-codes/${id}`)
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
	},
	/**
     * Gets a list of invitation codes
     * @param {boolean} redeemed 
     * @param {number} offset 
     * @param {number} limit 
     */
	async list({hasBeenRedeemed, offset, limit}) {
		let value = await api.get(`/invitation-codes/`, {
			params: {
				hasBeenRedeemed,
				offset,
				limit
			}
		})
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		return {
			items: data,
			total: value.data.metadata.pagination.totalRecords
		}
	},
	async listAll({ hasBeenRedeemed }) {
		const initial = await this.list({ hasBeenRedeemed, offset: 0, limit: 40 })
		if (initial.total <= initial.items.length) {
			return initial
		}
		return this.list({ hasBeenRedeemed, offset: 0, limit: initial.total })
	},
	async get(id) {
		if (typeof id !== "string" || id.length < 1) {
			throw new Error("ID must be a string longer than 0")
		}
		let value = await api.get(`/invitation-codes/${id}`)
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data[0]
		return data
	},
	async valid(id) {
		if (typeof id !== "string" || id.length < 1) {
			throw new Error("ID must be a string longer than 0")
		}
		let value = await api.get(`/invitation-codes/${id}/valid`)
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data[0]
		return data
	},
	async getClientdata(id){
		if (typeof id !== "string" || id.length < 1) {
			throw new Error("ID must be a string longer than 0")
		}
		let value = await api.get(`/invitation-codes/${id}/clientdata`)
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		return data
	},
	async redeem(invitationcode) {
		if (typeof invitationcode !== "string" || invitationcode.length < 1) {
			throw new Error("invitationcode must be a string longer than 0")
		}
		let value = await api.put(`/invitation-codes/${invitationcode}/redeem`)
		if (!value || !value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data[0]
		return data
	},
	async createClient(invitationcode, name, country, RegNumber, password, email, firstname, lastname, isGuest = 0) {
		if (typeof invitationcode !== "string" || invitationcode.length < 1) {
			throw new Error("invitationcode must be a string longer than 0")
		}
		let value = await api.post(`/invitation-codes/${invitationcode}/create-client`, {password, country, RegNumber, name, email, firstname, lastname, isGuest})
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			if (value.data.error[0].details) {
				error.details = value.data.error[0].details
			}
			throw error
		}
		let data = value.data.data[0]
		return data
	},

	/* async createGuestuser(invitationcode, email, name, selectedCountry, companyRegistrationNumber, firstname, lastname ) {
		let value = await api.post(`/guestRegistration/`, {invitationcode, email, name, selectedCountry, companyRegistrationNumber, firstname, lastname})

		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			if (value.data.error[0].details) {
				error.details = value.data.error[0].details
			}
			throw error
		}
		return value.data.data
	} */
}